import { IFilter } from "../Tools/IFilter";
import { FilterGroup } from "../Tools/FilterGroup";
import { FiltersController } from "../Tools/FiltersController";

export class UniversesFilter implements IFilter {
    id: string;
    type: string;
    controller: FiltersController;
    parentGroup: FilterGroup;

    constructor(parentGroup: FilterGroup) {
        this.id = 'universes';
        this.type = 'universes';
        this.controller = new FiltersController();
        this.parentGroup = parentGroup;
    }

    html(): string {
        let html = `
        <form id="universesForm">
            <input id="inputIndoor" class="btn-default" type="checkbox" name="indoor" value="indoor"> Indoor
            <input id="inputBathroom" class="btn-default" type="checkbox" name="bathroom" value="bathroom"> Salle de bain
            <input id="inputOutdoor" class="btn-default" type="checkbox" name="outdoor" value="outdoor"> Outdoor
            <input id="inputJunior" class="btn-default" type="checkbox" name="junior" value="junior"> Junior
            <input id="inputB2B" class="btn-default" type="radio" name="platform" value="B2B"> B2B
            <input id="inputB2C" class="btn-default" type="radio" name="platform" value="B2C"> B2C
        </form>
        `;

        setTimeout(() => {
            if (this.parentGroup.isDestroyed) return;
            const form = $('#universesForm');

            form.find('input[type="checkbox"]').each((_index, element) => {
                $(element).prop('checked', FilterGroup.filters.universes[$(element).attr('name')]);
                this.controller.addEventListener('change', () => {
                    const name = (element as HTMLInputElement).name;
                    const checked = (element as HTMLInputElement).checked;
                    FilterGroup.filters.universes[name] = checked;
                    FilterGroup.getUpdateFunctions(this.parentGroup.filtersFunction)(FilterGroup.filters);
                }, element.id);
            });

            form.find('input[type="radio"]').each((_index, element) => {
                let currentVal = FilterGroup.filters.universes.B2B ? "B2B" : "B2C";
                $(element).prop('checked', currentVal === $(element).val());
                this.controller.addEventListener('change', () => {
                    const selectedValue = (element as HTMLInputElement).value;
                    FilterGroup.filters.universes.B2B = (selectedValue === "B2B");
                    FilterGroup.getUpdateFunctions(this.parentGroup.filtersFunction)(FilterGroup.filters);
                }, element.id);
            });
        }, 50);

        return html;
    }

    destroy(): void {
        this.controller.destroy();
    }
}